export default {
  props: {
    companyID: { type: Number, required: true },
    companyName: { required: true },
    name: { type: String, required: true },
    isAvailableToEdit: { type: Boolean, default: true }
  },
  watch: {
    companyID: {
      immediate: true,
      handler: 'handleChangeCompanyID'
    }
  },
  computed: {
    tabID () {
      return `${this.name} + ${this.companyID}`
    }
  },
  methods: {
    handleChangeCompanyID (value) {
    }
  }
}
